<markdown [data]="headlineContent" (ready)="onMarkdownReady()"></markdown>
@if (detailContent) {
  <button type="button" class="detail-toggle" [class.expanded]="expanded" (click)="toggle()">
    <span>{{ (expanded ? 'Collapse' : 'Expand') | translate }}</span>
    <mat-icon class="detail-chevron">expand_more</mat-icon>
  </button>
  @if (expanded) {
    <markdown [data]="detailContent" (ready)="onMarkdownReady()"></markdown>
  }
}
